<template>
    <div class="features container">
      <div class="row">
        <ol class="breadcrumb features-title">
          <li><a href="/index">首页</a></li>
          <li><a href="/features">功能介绍</a></li>
        </ol>
      </div>
      <div class="row">
        <div class="features-text-wrapper col-md-12">
          <div class="feature-text">
            <div class="feature-item">
              <h2><span>跨平台展示工程模型和图纸</span></h2>
              <p>OBV前端视图基于WebGL技术，实现了大多数工程文件在网页显示的功能，提供了一种快捷查看BIM模型的方式。用户可以直接在网页、手机、平板上浏览工程模型和相关图纸，摆脱了专业软件的束缚，随时随地浏览三维模型，满足沟通交流、设计审图、施工管理、物业运维等各种场景的需求。</p>
              <p>目前支持的工程文件格式包括：rvt, rfa, rte, nwc, nwd, dwf, dwfx, dwg, dxf, rvm, 3dm , 3ds, bmp, bpn, CATPart, csv, dae, dgn, doc, docx, dri, fbx, gif, gltf, htm, html, iam, idgndb, ifc, iges, igs, imodel, ipt, jpeg, jpg, jt, lwo, mpp, mpt, ms3d, obj, obm, oxps, pdf, pkgb, pla, pln, png, ppt, pptx, prj, rcp, rcs, sat, skp, sldprt, step, stl, t, tiff, txt, vsd, vsdm, vsdx, wrl, wrz, x3d, xgl, xls, xlsx, xml, xps</p>
              <p class="support-format-list"></p>
              <!--<p class="support-format-list">*.rvt，*.dwf，*.nwd，*.obj，*.doc......</p>-->

              <div class="img-wrapper">
                <img src="../../../static/img/san-wei-tu-zhi.png" alt=""><br />
              </div>
              <div class="img-wrapper">
                <img src="../../../static/img/er-wei-tu-zhi.png" alt="" ><br />
              </div>
            </div>
            <div class="feature-item">
              <h2><span>在模型或图纸上进行二次开发</span></h2>
              <p>OBV前端视图提供了丰富的JavaScript和TypeScript的API，开发人员可根据自身系统的业务特点实现定制功能，以满足多种应用场景。开发人员可以在模型显示的基础上添加外部因素（如：批注，文字，说明等），可以根据项目的需求改变构件的显示状态（如：显示/隐藏，隔离，关注等）。</p>
              <p>请见：<a href="./../live-demo">代码示例</a></p>
              <div class="img-wrapper">
                <img src="../../../static/img/er-ci-kai-fa.png" alt="" ><br />
              </div>
              <p><i class="circle"></i>二次开发平台提供的文档：</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1）服务端API；</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2）JS API；</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3）快速入门；</p>
            </div>
            <div class="feature-item">
              <h2><span>多专业、多模型在线集成</span></h2>
              <p>通常一个工程由多个专业组成，包括建筑，电气，给排水等，而一个专业又由多层楼构成，一层楼又分为不同的设备，装置等等，多个模型文件可以在OBV前端视图进行集成，并可自有指定相对位置。组装成一个全专业的完整模型后，可以通过查看一个统一的模型树来观察该工程所有的构件情况。</p>
              <div class="img-wrapper">
                <img src="../../../static/img/mo-xing-zu-zhuang.png" alt="" >
                <br />
              </div>
            </div>
            <div class="feature-item">
              <h2><span>在模型上加入VR视觉体验</span></h2>
              <p>在模型上加入VR视觉体验效果，让用户像体验游戏情景一样进入大型模型内部进行查看，感受真实效果。</p>
              <div class="img-wrapper">
                <img src="../../../static/img/virtual-reality.jpg" alt="" ><br />
              </div>
            </div>

            <div class="feature-item">
              <h2><span>调用服务端接口获取BIM数据</span></h2>
              <p>转换后的BIM模型数据在云端进行结构化存储，BIM模型文件通过数字信息仿真模拟建筑物所具有的真实信息。此处的信息内涵不仅包含几何形状的视觉信息，还包含大量的非几何信息，例如：构件的材质，采购信息等，开发人员通过调用服务端数据接口可以实现对BIM构件的检索和读取构件相关信息。</p>
              <!--<div class="img-wrapper">-->
                <!--<img src="../../../static/img/BIM-shuju.png" alt="" >-->
                <!--<br />-->
              <!--</div>-->
              <p><i class="circle"></i>调用服务端接口可实现的功能：</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1）通过“模型树”，可以分级单独查看局部模型；</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2）选中关注的构件，然后点击“特性”按钮，右侧就会出现该构件的所有相关信息列表；</p>
              <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3）根据规定的属性筛选符合条件的构件。</p>
            </div>
            <div class="feature-item">
              <h2><span>OBV平台的私有部署</span></h2>
              <p>OBV平台支持私有部署在客户自己的服务器上，最大限度的保护设计成果的知识产权，杜绝BIM模型和数据的流失。</p>
              <div class="img-wrapper">
                <!--<img src="../../../static/img/BIM-shuju.png" alt="" >-->
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: 'features',
    mounted() {
    },
};
</script>

<style scoped lang='stylus' rel='stylesheet/stylus'>
  @import '~common/stylus/variable'
  .features
    background:$background-white
    color:$font-black
    .features-title
      background:$background-white
      a
        text-decoration :none
    .features-text-wrapper
      padding:15px
      .feature-item
        padding:15px
        line-height:30px
        /*background:#f66*/
        p
          text-indent:2em
          .support-format-list
            font-weight :bold
          .circle
            display: inline-block;
            margin-right: 5px;
            width: 12px;
            height: 12px;
            border-radius: 100%;
            background: #0e73af;
        h2
          margin: 20px 0 30px;
          font-size:$font-size-big
          text-align:center
          position:relative
          line-height:28px
          &:first-child
            margin:20px 0 30px
          &:before
            content: "";
            display: block;
            border-bottom: 1px solid #ccc;
            position: absolute;
            top: 15px;
            left: 0;
            width: 100%;
            z-index: 0;
          span
            display: inline-block;
            background-color: $background-white;
            padding: 0 20px;
            position: relative;
            z-index: 1;
        .img-wrapper
          display:flex
          justify-content: center;
          align-items: center;
          padding:20px

</style>



// WEBPACK FOOTER //
// src/pages/features/features.vue